module.exports = __webpack_public_path__ + "img/MERCADO_LIBRE.82d2d7b3.png";